import React from "react";
import { useDroppable } from "@dnd-kit/core";
import DraggableBox from "./DraggableBox";
import { Typography, Box } from "@mui/material";
import { theme } from "../Theme";

function DroppableAddSection({ id, children, items, setUsers, setItems }) {
  const { isOver, setNodeRef } = useDroppable({
    id,
  });

  const textStyle = {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    p: 0,
  };
  const handleBoxClick = (clickedId) => {
    const chartTemplate = items.find((item) => item.id === clickedId);
    if (!chartTemplate) return;

    const uniqueId = `${clickedId}-${Date.now()}`;
    const newChart = {
      ...chartTemplate,
      id: uniqueId,
    };

    setUsers((prevUsers) => [...prevUsers, newChart]);
    setItems((prevItems) => ({
      ...prevItems,
      addSection: prevItems.addSection.filter((item) => item.id !== clickedId),
    }));
  };

  return (
    <Box
      ref={setNodeRef}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: { xs: 0.75, sm: 1, md: 1.5 },
        padding: { xs: 0.75, sm: 1, md: 1.5 },
        margin: 1,
        flex: 1,
        minWidth: 0,
      }}
    >
      {children.length > 0 ? (
        children.map((child) => (
          <DraggableBox
            key={child.id}
            id={child.id}
            name={child.title ?? child.name}
            onClick={() => handleBoxClick(child.id)}
          />
        ))
      ) : (
        <Box sx={{ width: "100%", py: 1 }}>
          <Typography
            sx={{ ...textStyle, fontSize: { xs: "0.8rem", sm: "0.875rem" } }}
          >
            This list is empty. When you close a chart, it will be listed
            here - click to reopen it.
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default DroppableAddSection;
